// extracted by mini-css-extract-plugin
export default {"statusMessage":"efbee6d6d685","walkthroughHeading":"e10535a70d50","panelContent":"c345ce29c636"};